import type { AdvancedSearchField, TrackSearchSuggestion } from './types';

export const TRACK_SUGGESTION_MAP: Record<
  AdvancedSearchField,
  TrackSearchSuggestion
> = {
  status: 'SearchByStatus',
  comments: 'SearchByComments',
  visuals: 'SearchByVisuals',
  keyword: 'SearchByKeyword',
  uploader: 'SearchByUploader',
  resolution: 'SearchByResolution',
  format: 'SearchByFormat',
  transcription: 'SearchByTranscription',
  date: 'SearchByDate',
  duration: 'SearchByDuration',
  fileSize: 'SearchByFileSize',
  assignee: 'SearchByAssignee',
  fileType: 'SearchByFileType',
};
